<div class="checkbox-btn d-flex align-items-center">
    <ng-content></ng-content>
    <input [checked]="isChecked()" (input)="checked.emit()" type="checkbox" [value]="label()" [id]="uniqueId()" [name]="label() + type()" />

    <label [for]="uniqueId()" onclick [class.label-padding]="labelPadding()">{{ label() }}</label>

    <span class="item-count">({{ doc_count() }})</span>
</div>